import React, { useEffect, useState } from "react";
import { notification, Radio, Tooltip, Grid } from "antd";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";

import { Box, Button, Input } from "components";
import {
  BarCodeIcon,
  CopyIcon,
  InformationIcon,
  SendCompleteIcon,
} from "icons";
import { ChangePassword } from "screens";
import {
  DefaultSettingActionCreators,
  SettingInformationActionCreators,
} from "redux/rootActions";
import { settingInformationDataResponse } from "redux/setting/general/generalSettingStates";
import {
  selectIsLoadingDefaultSetting,
  defaultSettingDataResponse,
} from "redux/setting/default/defaultSettingStates";
import { httpStatus } from "configs/httpStatus";

import {
  LastCheckboxStyled,
  RadioStyled,
  RequestCheckItem,
  RequestFormLabel,
  Wrapper,
  WrapperCheckbox,
  WrapperGroupRadio,
  WrapperInforIcon,
  WrapperLink,
  WrapperSection,
  WrapperSection2,
  WrapperTitle,
  WrapperTooltip,
  WrapperUniqueLabel,
} from "./Setting.style";

const { useBreakpoint } = Grid;

const Setting: React.FC = () => {
  const dispatch = useDispatch();
  const screens = useBreakpoint();
  const qrRef = useRef<any>(null);

  const loadingDefaultSetting = useSelector(selectIsLoadingDefaultSetting);

  const settingInformationData = useSelector(settingInformationDataResponse);
  const defaultSettingData = useSelector(defaultSettingDataResponse);

  const [inforSetting, setInforSetting] = useState({
    isVerifyIdentityCode: false,
    identityCodeTitle: "",
    name: "",
    superCityCode: "",
  });
  const [url, setUrl] = useState("");
  const [isVisibleImg, setIsVisibleImg] = useState(false);
  const [loadings, setLoadings] = useState<boolean[]>([]);
  const [visibleTooltip, setVisibleTooltip] = useState<{
    placement: string;
    visible: boolean;
  }>({
    placement: "",
    visible: false,
  });
  const [radioChecked, setRadioChecked] = useState<boolean>(false);

  // useEffect(() => {
  //   dispatch(SettingInformationActionCreators.getSettingInformationAction());
  // }, []);

  useEffect(() => {
    if (
      defaultSettingData &&
      defaultSettingData.status === httpStatus.StatusOK
    ) {
      notification.open({
        message: moment(new Date()).format("YYYY/MM/DD HH:mm"),
        description: "設定を反映しました",
        icon: <SendCompleteIcon />,
        placement: "bottomRight",
      });
      dispatch(SettingInformationActionCreators.getSettingInformationAction());
      dispatch(DefaultSettingActionCreators.handleResetAction());
    }
  }, [defaultSettingData]);

  useEffect(() => {
    if (settingInformationData) {
      if (settingInformationData.status === httpStatus.StatusOK) {
        if (settingInformationData?.result) {
          const {
            super_city_code,
            identity_code_title,
            is_verify_identity_code,
            name,
            is_show_title,
          } = settingInformationData?.result;
          setInforSetting({
            isVerifyIdentityCode: is_verify_identity_code,
            identityCodeTitle: identity_code_title,
            name,
            superCityCode: super_city_code,
          });

          setRadioChecked(is_show_title);
          const idCodeTitle = is_show_title ? identity_code_title : "";

          const { origin } = window.location;
          const pathName = "/personalregistration/SII";
          const newUrl = `${origin}${pathName}?name=${name}&super-city-code=${super_city_code}&identity-code-title=${idCodeTitle}&is-verify-identity-code=${is_verify_identity_code}`;
          setUrl(newUrl);
        }
      } else {
        dispatch(
          DefaultSettingActionCreators.setDefaultSettingAction({
            is_verify_identity_code: true,
            identity_code_title: "",
            is_show_title: false,
          })
        );
      }
    }
  }, [settingInformationData]);

  const InfoIcon = (data?: any) => (
    <WrapperInforIcon
      onMouseEnter={() => setIsVisibleImg(true)}
      onMouseLeave={() => setIsVisibleImg(false)}
    >
      <InformationIcon offset="4" />
      {isVisibleImg && (
        <WrapperTooltip>
          <div>
            <img src={data.url} />
          </div>
        </WrapperTooltip>
      )}
    </WrapperInforIcon>
  );

  const handleVerifyIdentityCodeOnChange = (e: any) => {
    setInforSetting((prevState) => ({
      ...prevState,
      isVerifyIdentityCode: e.target.checked,
    }));
  };
  const handleIdentityCodeTitlteOnChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setInforSetting((prevState) => ({
      ...prevState,
      identityCodeTitle: e.target.value,
    }));
  };

  const handleLoading = (
    index: number,
    duration: number,
    copy?: boolean,
    placement?: string
  ) => {
    if (copy && placement) {
      setVisibleTooltip({
        placement,
        visible: true,
      });
    }
    setLoadings((prevLoadings) => {
      const newLoadings = [...prevLoadings];
      newLoadings[index] = true;
      return newLoadings;
    });

    setTimeout(() => {
      setLoadings((prevLoadings) => {
        const newLoadings = [...prevLoadings];
        newLoadings[index] = false;
        return newLoadings;
      });
      if (copy) {
        setVisibleTooltip({
          placement: "",
          visible: false,
        });
      }
    }, duration);
  };

  const handleCopyLink = async (index: number, placement: "left" | "right") => {
    handleLoading(index, 1000, true, placement);
    await navigator.clipboard.writeText(url);
  };

  const generateQRAndDownload = async (index: number) => {
    handleLoading(index, 2000);

    const canvas = qrRef.current?.querySelector("canvas");
    if (!canvas) return;
    const url = canvas.toDataURL("image/png");
    const a = document.createElement("a");
    a.href = url;
    a.download = `${
      inforSetting.name ? `${inforSetting.name}_` : ""
    }登録QRコード.png`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const handleStyle = (index: number) => {
    return {
      opacity: loadings[index] ? 0.5 : 1,
      pointerEvents: loadings[index] ? "none" : "unset",
      cursor: loadings[index] ? "not-allowed" : "unset",
    };
  };

  return (
    <Box title="各種設定">
      <div style={{ position: "relative", padding: "32px 16px" }}>
        <WrapperSection style={{ marginBottom: 30 }}>
          <div ref={qrRef} className="hidden">
            <QRCodeCanvas
              value={url}
              size={1024}
              marginSize={2}
              // scale={4}
              imageSettings={{
                src: "/images/logo-qr.png",
                x: undefined,
                y: undefined,
                height: 82,
                width: 160,
                opacity: 1,
                excavate: true,
              }}
            />
          </div>

          <WrapperTitle>
            <RequestFormLabel>
              <div className="label">固有番号登録</div>
              {screens.md ? (
                <WrapperCheckbox>
                  <LastCheckboxStyled
                    checked={inforSetting.isVerifyIdentityCode}
                    onChange={handleVerifyIdentityCodeOnChange}
                  >
                    <RequestCheckItem>
                      固有番号登録を有効にする
                    </RequestCheckItem>
                  </LastCheckboxStyled>
                  <InfoIcon url="/images/sign-up.png" />
                </WrapperCheckbox>
              ) : (
                <></>
              )}
            </RequestFormLabel>
          </WrapperTitle>

          {/* <WrapperMethod>
            <div className="title">承認方法：</div>
            <Radio.Group
              onChange={() => console.log("test")}
              value={"radioValue"}
              style={{ marginRight: 32 }}
            >
              <AudioWrapper>
                <Radio value="auto">自動承認</Radio>
                <Radio value="manual">手動承認</Radio>
              </AudioWrapper>
            </Radio.Group>
            <WrapperCheckbox>
              <LastCheckboxStyled
                checked={true}
                onChange={() => {
                  console.log("test");
                }}
              >
                <CheckBoxLabel>多言語対応</CheckBoxLabel>
              </LastCheckboxStyled>
            </WrapperCheckbox>
          </WrapperMethod> */}

          {!screens.md ? (
            <WrapperCheckbox style={{ marginBottom: 16 }}>
              <LastCheckboxStyled
                checked={inforSetting.isVerifyIdentityCode}
                onChange={handleVerifyIdentityCodeOnChange}
              >
                <RequestCheckItem>固有番号登録を有効にする</RequestCheckItem>
              </LastCheckboxStyled>
              <WrapperInforIcon
                style={{ height: 20, paddingTop: 0 }}
                onMouseEnter={() => setIsVisibleImg(true)}
                onMouseLeave={() => setIsVisibleImg(false)}
              >
                <InformationIcon offset="4" />
                {isVisibleImg && (
                  <WrapperTooltip>
                    <div>
                      <img src="/images/sign-up.png" />
                    </div>
                  </WrapperTooltip>
                )}
              </WrapperInforIcon>
            </WrapperCheckbox>
          ) : (
            <></>
          )}
          <Wrapper>
            <WrapperUniqueLabel>
              <div className="title">固有番号のラベル</div>
              <Radio.Group
                onChange={(e: any) => setRadioChecked(e.target.checked)}
                // value={
                //   inforSetting?.identityCodeTitle.length ? "active" : false
                // }
                value={radioChecked ? radioChecked : undefined}
              >
                <WrapperGroupRadio>
                  {/* <Radio value="employeeNumber">社員番号</Radio> */}
                  {/* <Radio value="membershipNumber">会員番号</Radio> */}
                  <RadioStyled>
                    <Radio
                      value={true}
                      onClick={() => {
                        if (radioChecked) {
                          setRadioChecked(false);
                        }
                      }}
                    />
                  </RadioStyled>
                  <Input
                    width={180}
                    height={31}
                    value={inforSetting.identityCodeTitle}
                    onChange={handleIdentityCodeTitlteOnChange}
                  />
                </WrapperGroupRadio>
              </Radio.Group>
            </WrapperUniqueLabel>

            <WrapperLink>
              <div className="link" onClick={() => handleCopyLink(1, "left")}>
                登録用URL：
                <Tooltip
                  visible={
                    visibleTooltip.placement === "left" &&
                    visibleTooltip.visible
                      ? true
                      : false
                  }
                  title="URLをコピーしました。"
                  placement="topLeft"
                  autoAdjustOverflow={true}
                >
                  <span>{url}</span>
                </Tooltip>
              </div>
              <div className="function">
                <Tooltip
                  visible={
                    visibleTooltip.placement === "right" &&
                    visibleTooltip.visible
                      ? true
                      : false
                  }
                  title="URLをコピーしました。"
                  placement="topLeft"
                  autoAdjustOverflow={true}
                >
                  <div
                    className="copy"
                    onClick={() => handleCopyLink(1, "right")}
                    style={{ ...handleStyle(1) } as any}
                  >
                    <CopyIcon /> <div>URLをコピー</div>
                  </div>
                </Tooltip>
                <div
                  className="download"
                  onClick={() => generateQRAndDownload(2)}
                  style={{ ...handleStyle(2) } as any}
                >
                  <BarCodeIcon />
                  <div>2次元コードをダウンロード</div>
                </div>
              </div>
            </WrapperLink>

            {/* <WrapperOption>
              <div className="title">
                オプション
                <span>
                  （チェックした項目が登録時の必須記入項目として表示される）
                </span>
              </div>
              <Checkbox.Group
                style={{ width: "100%" }}
                onChange={() => console.log("test")}
                //   defaultValue={defaultValue}
                //   value={value}
              >
                <WrapperGroupCheckbox>
                  <CheckboxStyled value="1">性別</CheckboxStyled>
                  <CheckboxStyled value="1">生年月日</CheckboxStyled>
                  <CheckboxStyled value="1">フリーコメント</CheckboxStyled> */}
            {/* <WrapperPrivateCheckbox>
                    <CheckboxStyled value="1">
                      第２登録番号ラベル
                    </CheckboxStyled>
                    <Input height={31} width={180} />
                  </WrapperPrivateCheckbox>

                  <WrapperPrivateCheckbox2>
                    <CheckboxStyled value="1">所属</CheckboxStyled>
                    <div className="label">カスタムラベル</div>
                    <Input height={31} width={420} />
                  </WrapperPrivateCheckbox2> */}
            {/* </WrapperGroupCheckbox>
              </Checkbox.Group>
            </WrapperOption> */}
          </Wrapper>

          <Button
            name="保存"
            background="#2AC769"
            color="#FFFFFF"
            border="none"
            fontSize={16}
            fontWeight={700}
            padding="5px 16px"
            width="64px"
            lineHeight="26px"
            onClick={() => {
              dispatch(
                DefaultSettingActionCreators.setDefaultSettingAction({
                  is_verify_identity_code: inforSetting.isVerifyIdentityCode,
                  identity_code_title: inforSetting.identityCodeTitle,
                  is_show_title: radioChecked,
                })
              );
            }}
            disabled={loadingDefaultSetting}
            loading={loadingDefaultSetting}
          />
        </WrapperSection>

        <WrapperSection2>
          <WrapperTitle>
            <RequestFormLabel>
              <div className="label">パスワード変更</div>
            </RequestFormLabel>
          </WrapperTitle>

          <ChangePassword />
        </WrapperSection2>
      </div>
    </Box>
  );
};

export default Setting;
